import React from 'react';
import { EmptyHeartIcon, HeartIcon } from '../../Icons';
export var LikeButton = function (props) {
    var type = props.isMini ? 'mini' : 'oval';
    var width = props.width || 24;
    return (React.createElement("div", { className: "like-button", onClick: props.onClick }, props.isFilled ? (React.createElement(HeartIcon, { width: width, className: type + " heart-icon-filled" })) : (React.createElement(EmptyHeartIcon, { width: width, className: type + " heart-icon" }))));
};
//# sourceMappingURL=button-like.js.map